// This file is auto-generated by @hey-api/openapi-ts

import { z } from 'zod';

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type { AddCaseToGroupData, AddCaseToGroupErrors, AddCaseToGroupResponses, AddCorrectionData, AddCorrectionErrors, AddCorrectionResponses, CreateCaseData, CreateCaseErrors, CreateCaseResponses, CreateReleaseData, CreateReleaseErrors, CreateReleaseResponses, CreateReviewData, CreateReviewErrors, CreateReviewResponses, CreateSuiteData, CreateSuiteErrors, CreateSuiteResponses, CreateTestGroupData, CreateTestGroupErrors, CreateTestGroupResponses, DeleteCaseData, DeleteCaseErrors, DeleteCaseResponses, DeleteCaseRunData, DeleteCaseRunErrors, DeleteCaseRunResponses, GetCaseData, GetCaseErrors, GetCaseResponses, GetCaseRunData, GetCaseRunErrors, GetCaseRunResponses, GetDocumentContentData, GetDocumentContentErrors, GetDocumentContentResponses, GetImportStatusData, GetImportStatusErrors, GetImportStatusResponses, GetIntakeData, GetIntakeErrors, GetIntakeResponses, GetRegistryData, GetRegistryErrors, GetRegistryResponses, GetReleaseData, GetReleaseErrors, GetReleaseResponses, GetReviewQueueData, GetReviewQueueErrors, GetReviewQueueResponses, GetSuiteData, GetSuiteErrors, GetSuiteReportData, GetSuiteReportErrors, GetSuiteReportResponses, GetSuiteResponses, GetTestGroupData, GetTestGroupErrors, GetTestGroupResponses, HealthData, HealthResponses, ImportDocumentsData, ImportDocumentsErrors, ImportDocumentsResponses, ListAuditFieldsData, ListAuditFieldsErrors, ListAuditFieldsResponses, ListCaseRunsData, ListCaseRunsErrors, ListCaseRunsResponses, ListCasesData, ListCasesErrors, ListCasesResponses, ListCorrectionsData, ListCorrectionsErrors, ListCorrectionsResponses, ListDocumentsData, ListDocumentsErrors, ListDocumentsResponses, ListTestGroupsData, ListTestGroupsErrors, ListTestGroupsResponses, RemoveCaseFromGroupData, RemoveCaseFromGroupErrors, RemoveCaseFromGroupResponses, RetryAwaitingCasesData, RetryAwaitingCasesErrors, RetryAwaitingCasesResponses, ReviewAuditFieldData, ReviewAuditFieldErrors, ReviewAuditFieldResponses, ReviseReviewData, ReviseReviewErrors, ReviseReviewResponses, StartCaseRunData, StartCaseRunErrors, StartCaseRunResponses, StartSuiteData, StartSuiteErrors, StartSuiteResponses, StreamCaseRunData, StreamCaseRunErrors, StreamCaseRunResponse, StreamCaseRunResponses, UpdateLabelData, UpdateLabelErrors, UpdateLabelResponses } from './types.gen';
import { zAddCaseToGroupPath, zAddCaseToGroupResponse, zAddCorrectionBody, zAddCorrectionPath, zAddCorrectionResponse, zCreateCaseBody, zCreateCaseResponse, zCreateReleaseBody, zCreateReleasePath, zCreateReleaseResponse, zCreateReviewBody, zCreateReviewResponse, zCreateSuiteBody, zCreateSuiteResponse, zCreateTestGroupBody, zCreateTestGroupResponse, zDeleteCasePath, zDeleteCaseResponse, zDeleteCaseRunPath, zDeleteCaseRunResponse, zGetCasePath, zGetCaseResponse, zGetCaseRunPath, zGetCaseRunResponse, zGetDocumentContentPath, zGetDocumentContentResponse, zGetImportStatusPath, zGetImportStatusResponse, zGetIntakePath, zGetIntakeResponse, zGetReleasePath, zGetReleaseResponse, zGetReviewQueueQuery, zGetReviewQueueResponse, zGetSuitePath, zGetSuiteReportPath, zGetSuiteReportQuery, zGetSuiteReportResponse, zGetSuiteResponse, zGetTestGroupPath, zGetTestGroupResponse, zImportDocumentsPath, zImportDocumentsResponse, zListAuditFieldsPath, zListAuditFieldsResponse, zListCaseRunsPath, zListCaseRunsResponse, zListCasesQuery, zListCasesResponse, zListCorrectionsPath, zListCorrectionsResponse, zListDocumentsPath, zListDocumentsResponse, zListTestGroupsResponse, zRemoveCaseFromGroupPath, zRemoveCaseFromGroupResponse, zRetryAwaitingCasesResponse, zReviewAuditFieldBody, zReviewAuditFieldPath, zReviewAuditFieldResponse, zReviseReviewBody, zReviseReviewPath, zReviseReviewResponse, zStartCaseRunBody, zStartCaseRunPath, zStartCaseRunResponse, zStartSuitePath, zStartSuiteResponse, zStreamCaseRunHeaders, zStreamCaseRunPath, zStreamCaseRunResponse, zUpdateLabelBody, zUpdateLabelPath, zUpdateLabelResponse } from './zod.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Health
 *
 * Liveness and readiness probe.
 */
export const health = <ThrowOnError extends boolean = false>(options?: Options<HealthData, ThrowOnError>) => (options?.client ?? client).get<HealthResponses, unknown, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    url: '/status/health',
    ...options
});

/**
 * Get Registry
 *
 * The scored field patterns and their comparators.
 */
export const getRegistry = <ThrowOnError extends boolean = false>(options?: Options<GetRegistryData, ThrowOnError>) => (options?.client ?? client).get<GetRegistryResponses, GetRegistryErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/registry',
    ...options
});

/**
 * List Cases
 */
export const listCases = <ThrowOnError extends boolean = false>(options?: Options<ListCasesData, ThrowOnError>) => (options?.client ?? client).get<ListCasesResponses, ListCasesErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zListCasesQuery.optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListCasesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases',
    ...options
});

/**
 * Create Case
 *
 * Create a case from an RFP. Its baseline is the RFP's first carrier
 * submission, which bp-api and carrier-rfpq look up. An RFP with one makes a
 * draft case holding it; any other RFP makes a case awaiting a refresh. 400 when
 * source_rfp_id is not an RFP ID; 503, with nothing written, when the lookup
 * cannot be made. An RFP has at most one case that is not deleted: 409, with
 * nothing written and before any lookup, when it has one, and appError.message
 * names that case. An RFP whose cases are all deleted makes a new one.
 */
export const createCase = <ThrowOnError extends boolean = false>(options: Options<CreateCaseData, ThrowOnError>) => (options.client ?? client).post<CreateCaseResponses, CreateCaseErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateCaseBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateCaseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Case
 *
 * Soft-delete a case: hidden, and out of every test group. The releases
 * and suite reports that already hold it keep it.
 */
export const deleteCase = <ThrowOnError extends boolean = false>(options: Options<DeleteCaseData, ThrowOnError>) => (options.client ?? client).delete<DeleteCaseResponses, DeleteCaseErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteCasePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteCaseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}',
    ...options
});

/**
 * Get Case
 */
export const getCase = <ThrowOnError extends boolean = false>(options: Options<GetCaseData, ThrowOnError>) => (options.client ?? client).get<GetCaseResponses, GetCaseErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCasePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetCaseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}',
    ...options
});

/**
 * List Case Runs
 *
 * The case's runs, newest first, each with the replay RFP RUMI filled.
 */
export const listCaseRuns = <ThrowOnError extends boolean = false>(options: Options<ListCaseRunsData, ThrowOnError>) => (options.client ?? client).get<ListCaseRunsResponses, ListCaseRunsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListCaseRunsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListCaseRunsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/runs',
    ...options
});

/**
 * Start Case Run
 *
 * Run the deployed RUMI on a case, to qualify it as golden. The run
 * records the version that ran when it ends, and its review opens when it finishes.
 * A case has one case run in flight: a queued run is started again rather than
 * queued twice. 400 for an unknown replay kind; 409 for a case with no baseline,
 * no broker documents where documents are imported, or a run still running;
 * 503 when the run may not have started (try again to start the same run) or
 * this deployment runs no RUMI.
 */
export const startCaseRun = <ThrowOnError extends boolean = false>(options: Options<StartCaseRunData, ThrowOnError>) => (options.client ?? client).post<StartCaseRunResponses, StartCaseRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zStartCaseRunBody,
        path: zStartCaseRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zStartCaseRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/runs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete Case Run
 *
 * Soft-delete a finished or failed case run. Suite runs are kept.
 * 409 for a run that is queued or running, a suite's run, or a run a suite's
 * report takes as a reference run. When the case in review is left without
 * its audit sample, the review starts over from the earliest remaining scored
 * case run, or the case waits in draft.
 */
export const deleteCaseRun = <ThrowOnError extends boolean = false>(options: Options<DeleteCaseRunData, ThrowOnError>) => (options.client ?? client).delete<DeleteCaseRunResponses, DeleteCaseRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zDeleteCaseRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseValidator: async (data) => await zDeleteCaseRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/runs/{run_id}',
    ...options
});

/**
 * Get Case Run
 *
 * A run with its latest score's totals and every discrepancy in that
 * score, reviewed or still open.
 */
export const getCaseRun = <ThrowOnError extends boolean = false>(options: Options<GetCaseRunData, ThrowOnError>) => (options.client ?? client).get<GetCaseRunResponses, GetCaseRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetCaseRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetCaseRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/runs/{run_id}',
    ...options
});

/**
 * Stream Case Run
 *
 * The run as server-sent events, while RUMI works on it. First a run
 * event with the run (CaseRunOut), then a step event for each step of its RUMI
 * run so far (RunStepOut, with the step's seq as the event id), then each new
 * step and each change of the run's state as they happen. An end event closes
 * the stream once the run has finished or failed. A run with no replay yet
 * sends its state alone. Last-Event-ID resumes after the step it names. A comment
 * line every 15 seconds keeps a quiet stream open. A step holds no text RUMI
 * or a tool produced.
 */
export const streamCaseRun = <ThrowOnError extends boolean = false>(options: Options<StreamCaseRunData, ThrowOnError, StreamCaseRunResponse>) => (options.client ?? client).sse.get<StreamCaseRunResponses, StreamCaseRunErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        headers: zStreamCaseRunHeaders.optional(),
        path: zStreamCaseRunPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'text',
    responseValidator: async (data) => await zStreamCaseRunResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/runs/{run_id}/events',
    ...options
});

/**
 * Update Label
 */
export const updateLabel = <ThrowOnError extends boolean = false>(options: Options<UpdateLabelData, ThrowOnError>) => (options.client ?? client).patch<UpdateLabelResponses, UpdateLabelErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zUpdateLabelBody,
        path: zUpdateLabelPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zUpdateLabelResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/label',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Retry Awaiting Cases
 *
 * Look up the baseline again for every case that waits for a refresh, and
 * return the cases that found it. 503, with nothing written, when a lookup cannot
 * be made or this deployment has no lookup.
 */
export const retryAwaitingCases = <ThrowOnError extends boolean = false>(options?: Options<RetryAwaitingCasesData, ThrowOnError>) => (options?.client ?? client).post<RetryAwaitingCasesResponses, RetryAwaitingCasesErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRetryAwaitingCasesResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/retry-awaiting',
    ...options
});

/**
 * Get Intake
 *
 * What the case's latest run gave RUMI: its replay's v5 export from
 * before RUMI ran. The replay is an intake copy of the source RFP made when the
 * run started, so it holds the broker's intake as the RFP stood then and none of
 * the analyst's build. 404 until a run of the case has recorded its intake.
 */
export const getIntake = <ThrowOnError extends boolean = false>(options: Options<GetIntakeData, ThrowOnError>) => (options.client ?? client).get<GetIntakeResponses, GetIntakeErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetIntakePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetIntakeResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/intake',
    ...options
});

/**
 * Get Import Status
 *
 * Whether the case's document import is running. A deployment that
 * imports no documents has none running. 503 when the job's state cannot be
 * read.
 */
export const getImportStatus = <ThrowOnError extends boolean = false>(options: Options<GetImportStatusData, ThrowOnError>) => (options.client ?? client).get<GetImportStatusResponses, GetImportStatusErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetImportStatusPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetImportStatusResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/import',
    ...options
});

/**
 * List Documents
 */
export const listDocuments = <ThrowOnError extends boolean = false>(options: Options<ListDocumentsData, ThrowOnError>) => (options.client ?? client).get<ListDocumentsResponses, ListDocumentsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListDocumentsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/documents',
    ...options
});

/**
 * Get Document Content
 *
 * The tool's copy of a production broker document. Every view is logged.
 * 404 for an excluded document, another case's, or a copy that is missing; 503
 * when this deployment keeps no copies.
 */
export const getDocumentContent = <ThrowOnError extends boolean = false>(options: Options<GetDocumentContentData, ThrowOnError>) => (options.client ?? client).get<GetDocumentContentResponses, GetDocumentContentErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetDocumentContentPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'blob',
    responseValidator: async (data) => await zGetDocumentContentResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/documents/{document_id}/content',
    ...options
});

/**
 * List Corrections
 */
export const listCorrections = <ThrowOnError extends boolean = false>(options: Options<ListCorrectionsData, ThrowOnError>) => (options.client ?? client).get<ListCorrectionsResponses, ListCorrectionsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListCorrectionsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListCorrectionsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/corrections',
    ...options
});

/**
 * Add Correction
 *
 * A correction on any field, without a discrepancy: for a field where RUMI
 * and the analyst made the same mistake.
 */
export const addCorrection = <ThrowOnError extends boolean = false>(options: Options<AddCorrectionData, ThrowOnError>) => (options.client ?? client).post<AddCorrectionResponses, AddCorrectionErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zAddCorrectionBody,
        path: zAddCorrectionPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zAddCorrectionResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/corrections',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Review Queue
 *
 * Open discrepancies, grouped by field key across cases.
 */
export const getReviewQueue = <ThrowOnError extends boolean = false>(options?: Options<GetReviewQueueData, ThrowOnError>) => (options?.client ?? client).get<GetReviewQueueResponses, GetReviewQueueErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: zGetReviewQueueQuery.optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetReviewQueueResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/review-queue',
    ...options
});

/**
 * Create Review
 *
 * One verdict on one discrepancy.
 */
export const createReview = <ThrowOnError extends boolean = false>(options: Options<CreateReviewData, ThrowOnError>) => (options.client ?? client).post<CreateReviewResponses, CreateReviewErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateReviewBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateReviewResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/reviews',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revise Review
 *
 * Set a discrepancy's verdict, or change the one it has, whatever the
 * case's state (review.revise_discrepancy).
 */
export const reviseReview = <ThrowOnError extends boolean = false>(options: Options<ReviseReviewData, ThrowOnError>) => (options.client ?? client).put<ReviseReviewResponses, ReviseReviewErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zReviseReviewBody,
        path: zReviseReviewPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zReviseReviewResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/field-results/{field_result_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Audit Fields
 *
 * The audit sample, with the value RUMI and the analyst agreed on, from
 * the sampled run's latest score, so the reviewer can check it.
 */
export const listAuditFields = <ThrowOnError extends boolean = false>(options: Options<ListAuditFieldsData, ThrowOnError>) => (options.client ?? client).get<ListAuditFieldsResponses, ListAuditFieldsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zListAuditFieldsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListAuditFieldsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/audit-fields',
    ...options
});

/**
 * Review Audit Field
 */
export const reviewAuditField = <ThrowOnError extends boolean = false>(options: Options<ReviewAuditFieldData, ThrowOnError>) => (options.client ?? client).post<ReviewAuditFieldResponses, ReviewAuditFieldErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zReviewAuditFieldBody,
        path: zReviewAuditFieldPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zReviewAuditFieldResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/audit-fields/{audit_field_id}/review',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List Test Groups
 */
export const listTestGroups = <ThrowOnError extends boolean = false>(options?: Options<ListTestGroupsData, ThrowOnError>) => (options?.client ?? client).get<ListTestGroupsResponses, ListTestGroupsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zListTestGroupsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups',
    ...options
});

/**
 * Create Test Group
 */
export const createTestGroup = <ThrowOnError extends boolean = false>(options: Options<CreateTestGroupData, ThrowOnError>) => (options.client ?? client).post<CreateTestGroupResponses, CreateTestGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateTestGroupBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateTestGroupResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Test Group
 */
export const getTestGroup = <ThrowOnError extends boolean = false>(options: Options<GetTestGroupData, ThrowOnError>) => (options.client ?? client).get<GetTestGroupResponses, GetTestGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetTestGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetTestGroupResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups/{name}',
    ...options
});

/**
 * Remove Case From Group
 */
export const removeCaseFromGroup = <ThrowOnError extends boolean = false>(options: Options<RemoveCaseFromGroupData, ThrowOnError>) => (options.client ?? client).delete<RemoveCaseFromGroupResponses, RemoveCaseFromGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zRemoveCaseFromGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zRemoveCaseFromGroupResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups/{name}/cases/{case_id}',
    ...options
});

/**
 * Add Case To Group
 */
export const addCaseToGroup = <ThrowOnError extends boolean = false>(options: Options<AddCaseToGroupData, ThrowOnError>) => (options.client ?? client).put<AddCaseToGroupResponses, AddCaseToGroupErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zAddCaseToGroupPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zAddCaseToGroupResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups/{name}/cases/{case_id}',
    ...options
});

/**
 * Create Release
 */
export const createRelease = <ThrowOnError extends boolean = false>(options: Options<CreateReleaseData, ThrowOnError>) => (options.client ?? client).post<CreateReleaseResponses, CreateReleaseErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateReleaseBody,
        path: zCreateReleasePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateReleaseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/test-groups/{name}/releases',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Release
 */
export const getRelease = <ThrowOnError extends boolean = false>(options: Options<GetReleaseData, ThrowOnError>) => (options.client ?? client).get<GetReleaseResponses, GetReleaseErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetReleasePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetReleaseResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/releases/{name}',
    ...options
});

/**
 * Import Documents
 *
 * Start the document import job for a case. already_running is true
 * when an import of the case was running. 409 when this deployment imports no
 * documents or the case has no baseline yet; 503 when the job cannot start.
 */
export const importDocuments = <ThrowOnError extends boolean = false>(options: Options<ImportDocumentsData, ThrowOnError>) => (options.client ?? client).post<ImportDocumentsResponses, ImportDocumentsErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zImportDocumentsPath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zImportDocumentsResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/cases/{case_id}/import-documents',
    ...options
});

/**
 * Create Suite
 *
 * Start a suite: the deployed RUMI on a test group (frozen as a release)
 * or on an earlier release, compared in its report with each case's latest
 * earlier runs on another recorded version.
 *
 * The trigger sets the run limit, so it follows the caller: platform CI
 * (rumi-ci) starts only ci suites; manual and nightly suites need
 * rumi-tester.
 *
 * 400 for an unknown trigger or replay kind, repetitions outside 1 to 10, both
 * or neither of test_group and release, or more runs than the trigger's limit;
 * 404 for a test group or release that does not exist; 503 when the suite may
 * not have started, naming the start route that starts it.
 */
export const createSuite = <ThrowOnError extends boolean = false>(options: Options<CreateSuiteData, ThrowOnError>) => (options.client ?? client).post<CreateSuiteResponses, CreateSuiteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: zCreateSuiteBody,
        path: z.never().optional(),
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zCreateSuiteResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/suites',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get Suite
 */
export const getSuite = <ThrowOnError extends boolean = false>(options: Options<GetSuiteData, ThrowOnError>) => (options.client ?? client).get<GetSuiteResponses, GetSuiteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetSuitePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetSuiteResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/suites/{suite_id}',
    ...options
});

/**
 * Start Suite
 *
 * Start a queued suite whose start failed, or may have. Starting it
 * again is safe: its workflow id is fixed. The trigger rule is createSuite's.
 *
 * 403 when the caller may not start the suite's trigger; 404 for a suite that
 * does not exist; 409 for a suite that is not queued; 503 when the suite may
 * not have started.
 */
export const startSuite = <ThrowOnError extends boolean = false>(options: Options<StartSuiteData, ThrowOnError>) => (options.client ?? client).post<StartSuiteResponses, StartSuiteErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zStartSuitePath,
        query: z.never().optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zStartSuiteResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/suites/{suite_id}/start',
    ...options
});

/**
 * Get Suite Report
 *
 * The comparison report. With ``limit``, it also says whether the suite
 * passes the CI limit; only a finished suite passes. A run not yet scored at its
 * release's revision is scored then, with no judge; the finishing suite scores
 * that free text again with its judge. 400 for a limit that is not a whole number
 * from 0.
 */
export const getSuiteReport = <ThrowOnError extends boolean = false>(options: Options<GetSuiteReportData, ThrowOnError>) => (options.client ?? client).get<GetSuiteReportResponses, GetSuiteReportErrors, ThrowOnError>({
    requestValidator: async (data) => await z.object({
        body: z.never().optional(),
        path: zGetSuiteReportPath,
        query: zGetSuiteReportQuery.optional()
    }).parseAsync(data),
    responseType: 'json',
    responseValidator: async (data) => await zGetSuiteReportResponse.parseAsync(data),
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/golden/suites/{suite_id}/report',
    ...options
});
